import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckRegularReportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18.8 12.2q1 .6.4 1.6l-4 6.4q-.3.6-1 .6-.5 0-1-.5l-2.4-3.2a1.2 1.2 0 1 1 2-1.4l1.3 1.8 3-5q.8-.8 1.7-.3" }), /* @__PURE__ */ _jsx("path", { d: "M16 3.2a13 13 0 0 1 12.7 14.2l-.8-.1h-1.6l.1-1.3A10.4 10.4 0 1 0 15 26.4v.7q0 1 .5 1.7A12.8 12.8 0 0 1 16 3.2m2.9 19q1 .2 1.1 1.2V27q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.4q1 .1 1.1 1v8.3q-.1 1-1.1 1.1h-.8q-.8 0-1-.7l-.1-.4V19q.1-1 1.1-1.1zm4.5 1.4h.1l.3.2q.6.2.7 1V27q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1z" })]
});
export default SvgCheckRegularReportIcon;
